"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ExpandButton = _interopRequireDefault(require("../ExpandButton"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CompoundButton = _ref => {
  let {
    caption = '',
    danger = false,
    disabled = false,
    fontSize = '14px',
    icon,
    iconPosition = 'left',
    margin,
    onClick = () => null,
    size = 30
  } = _ref;
  const {
    dangerColor,
    disabledColor,
    primaryColor
  } = (0, _styledComponents.useTheme)();
  const handleClick = e => {
    if (disabled) return;
    e.stopPropagation();
    onClick();
  };
  const buttonProps = {
    circle: true,
    danger,
    disabled,
    icon,
    onClick: handleClick,
    size
  };
  const containerProps = {
    margin,
    onClick: handleClick
  };
  const labelProps = {
    color: disabled ? disabledColor : danger ? dangerColor : primaryColor,
    fontSize
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styled.ButtonContainer, _objectSpread(_objectSpread({}, containerProps), {}, {
    children: [iconPosition === 'left' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandButton.default, _objectSpread({}, buttonProps)), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.Label, _objectSpread(_objectSpread({}, labelProps), {}, {
      children: caption
    })), iconPosition === 'right' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandButton.default, _objectSpread({}, buttonProps))]
  }));
};
CompoundButton.propTypes = {
  caption: _propTypes.default.string,
  danger: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  fontSize: _propTypes.default.string,
  icon: _propTypes.default.string,
  iconPosition: _propTypes.default.oneOf(['left', 'right']),
  margin: _propTypes.default.string,
  onClick: _propTypes.default.func,
  size: _propTypes.default.number
};
var _default = exports.default = CompoundButton;